import styled, { css } from 'styled-components';

export const Content = styled.input`
  font-family: monospace;
  width: ${(props) => props.width};
  text-align: center;
  font-size: 13px;
  line-height: normal;
  border: 0;
  border-left: 1px solid #ccc;
  height: 30px;
  ${(props) =>
    props.$error &&
    css`
      color: #f00;
      box-shadow: inset 0 0 2px 1px rgba(255, 0, 0, 1);
    `}
`;
